// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","smallWidth":"768px","container":"AddFrameCard_container__uqMjf"};